import styled from '@emotion/styled';
import { BREAKPOINTS_LEGACY, TYPOGRAPHY } from '@sortlist-frontend/design-system/legacy';

export const Shape = styled.div`
  border-radius: 2rem;
`;

export const Title = styled.p`
  font-size: ${TYPOGRAPHY.H1};
  line-height: ${TYPOGRAPHY.LINE_HEIGHT_1};
  @media only screen and (max-width: ${BREAKPOINTS_LEGACY.xs}) {
    font-size: ${TYPOGRAPHY.H3};
  }
`;
